import "../styles/Plantilla.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Footer from "./Footer.jsx";
import ODS from "./ODS.jsx";
import Header from "./Header.jsx";
import Loading from "./Loading.jsx";

import config from "../config.js";
import engranajeIcon from "../assets/svg/engranaje.svg";
import carpetaIcon from "../assets/svg/carpeta.svg";
import recuerda from "../assets/imagenes/items/recuerda.jpg";
import { cleanText } from "../functions/general";
import Swal from "sweetalert2";

function Plantilla() {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingType, setLoadingType] = useState("");
  const navigate = useNavigate();

  const mostrarInformacion = () => {
    Swal.fire({
      title:
        "<span style='color: #223263;  margin-bottom: 5px;'>Información</span>",
      html: `
    <div style="margin: 0;">
      <p class="justificado">Nuestro sistema procesa archivos PDF académicos (hasta 10MB) en <span class="negrita"> español o inglés</span>.</p>
      <p class="justificado">Asegúrate de que el resumen (<span class="cursiva">abstract</span>) esté entre las primeras páginas y sea de una columna para un análisis óptimo.</p>
    </div>
    `,
      imageUrl: recuerda,
      imageWidth: 250,
      imageHeight: 250,
      imageAlt: "Custom image",
      confirmButtonText: "OK",
      confirmButtonColor: "#223263",
      customClass: {
        confirmButton: "custom-confirm-button",
      },
    });
  };

  //TEXT AREA
  const [charCount, setCharCount] = useState(0);
  const [text, setText] = useState("");

  const handleInputChange = (event) => {
    setCharCount(event.target.value.length);
    setText(event.target.value);
  };

  useEffect(() => {
    mostrarInformacion();
  }, []);

  //CARGAR ARCHIVO
  const [archivo, setArchivo] = useState(null);

  const uploadFile = (e) => {
    const file = e.target.files[0];
    const maxSizeInBytes = 10 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        html: "El archivo seleccionado es demasiado grande. <br> El tamaño máximo permitido es de 10MB.",
      });
      e.target.value = null;
      return;
    }

    if (file.type !== "application/pdf") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        html: "El archivo cargado no es de tipo PDF. <br> Por favor, seleccione un nuevo archivo.",
      });
      console.log(file.lastModifiedDate);

      e.target.value = null;
      return;
    }
    setArchivo(file);
  };

  const insertFile = async () => {
    if (archivo === null) {
      Swal.fire({
        icon: "info",
        title: "¿Vacio?",
        html: "Por favor, seleccione un archivo.",
      });
      return;
    }
    setIsLoading(true);
    setLoadingType("archivo");
    const f = new FormData();
    f.append("file", archivo);
    try {
      const response = await axios.post(
        `${config.API_URL}` + "/api/Clasificar/file",
        f,
        { headers: { "content-type": "multipart/form-data" } }
      );

      const result = response.data.data;
      console.log(result);
      console.log(response.data.contenido);
      navigate("/document", {
        state: {
          result,
          metadata: {
            name: archivo.name,
            size: archivo.size,
            fecha: archivo.lastModifiedDate,
            language: result.idioma,
            contenido: response.data.contenido,
          },
        },
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "ERROR",
        html: "No hemos podido identificar los requerimientos mínimos de análisis en tu archivo, prueba con otro.",
      });
    } finally {
      setIsLoading(false);
      setArchivo(null);
    }
  };

  //PROCESAR TEXTO

  const handleProcesarTexto = async () => {
    if (!text || cleanText(text).trim().length <= 128) {
      Swal.fire({
        icon: "info",
        title: "Texto insuficiente",
        html: "Escribe más de 128 caracteres.",
      });
      return;
    }
    setIsLoading(true);
    setLoadingType("texto");
    try {
      const response = await fetch(
        `${config.API_URL}` + "/api/Clasificar/text",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: `"${cleanText(text)}"`,
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json();
      console.log(result);
      navigate("/resultado", { state: { result } });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        html: "Algo salió mal. <br> Por favor, intenta de nuevo.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Desktop">
      {isLoading ? (
        <Loading type={loadingType} />
      ) : (
        <>
          <Header />

          <div className="Procesar">
            <div>
              <form>
                <div>
                  <span style={{ fontWeight: "bold" }}>
                    Cuantificando la Relación entre su Producto Académico y los
                    ODS
                  </span>
                </div>
                <div class="textarea-container">
                  <textarea
                    placeholder="Ingresa tu texto aquí (Sólamente inglés o español)"
                    maxLength="4096"
                    onChange={handleInputChange}
                  ></textarea>
                  <div className="file-upload-container">
                    <div className="button-with-hint">
                      <input
                        type="file"
                        className="file"
                        accept=".pdf"
                        multiple={false}
                        onChange={uploadFile}
                      />
                      <svg
                        onClick={mostrarInformacion}
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-info-circle-fill"
                        viewBox="0 0 16 16"
                        style={{ marginLeft: 5}}
                      >
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                      </svg>
                    </div>
                    <p class="char-counter">
                      <span id="charCount">{charCount}</span>/4096
                    </p>
                  </div>
                </div>
              </form>

              <div class="botones">
                <button
                  type="button"
                  className="procesar-file"
                  onClick={insertFile}
                >
                  <img src={carpetaIcon} className="button-icon" />
                  Procesar archivo
                </button>
                <button
                  type="button"
                  className="procesar-text"
                  onClick={handleProcesarTexto}
                >
                  <img src={engranajeIcon} className="button-icon" />
                  Procesar texto
                </button>
              </div>
            </div>
          </div>

          <ODS />

          <Footer />
        </>
      )}
    </div>
  );
}

export default Plantilla;
